<template>
  <b-modal
    class="accountDetailsModal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    ref="accountDetailsModal"
    @open="open"
  >
    <template slot="modal-header" class="flex-column">
      <h4 class="modal-title mt-0">{{title}}</h4>
      <p class="card-category mt-1 mb-0">{{subTitle}}</p>
    </template>
    <b-form @submit="onSubmit" @reset="onReset" v-if="userAccountDetailsLoaded">
      <b-row>
        <b-col>
          <b-form-row>
            <b-col>
              <b-form-group label="Company Name">
                <b-form-input
                  v-model="form.company"
                />
                <span class="error text-danger" v-show="form.error.company">Company Name cannot be empty...</span>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group label="Phone Number">
                <b-form-input
                  type="tel"
                  v-model="form.phone"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group label="Logo Image">
                <div class="company-logo-wrapper" :style="companyLogoStyle()">
                  <div class="compnay-logo-content">
                    <img ref="companyLogo" @load="loadCompanyLogo" :src="logoFileContent" />
                  </div>
                </div>
                <div class="company-logo-helper d-flex align-items-center mt-1">
                  <div class="company-logo-select mr-2">
                    <b-form-file v-model="logoFile" accept="image/*" class="file-logoFile" plain @input="chooseFile($event)" />
                    <p-button round type="info" size="sm" class="btn-logoFile-select mt-1">Browse</p-button>
                  </div>
                  <small :class="{'text-danger': form.error.logo, 'text-muted': !form.error.logo}">Size limited to 200 x 100 pixels</small>
                </div>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-col>
        <b-col>
          <b-form-row>
            <b-col>
              <b-form-group label="Address">
                <b-form-input
                  v-model="form.address.street"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group label="Address Line 2">
                <b-form-input
                  v-model="form.address.street2"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group label="City">
                <b-form-input
                  v-model="form.address.city"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="State">
                <b-form-input
                  v-model="form.address.state"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group label="Zip Code">
                <b-form-input
                  v-model="form.address.zip"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Country">
                <p class="form-control">{{form.address.country}}</p>
                <!-- <b-form-input
                  v-model="form.address.country"
                  disabled
                  value="US"
                /> -->
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-col>
      </b-row>
      <b-row class="form-actions my-3">
        <b-col>
          <p-button type="success" round size="sm" class="pull-right" :disabled="hasError() || processing" @click.native="onSubmitForm" :loading="processing">Save</p-button>
          <p-button type="danger" round size="sm" class="pull-right mr-2" @click.native="onCancel">Cancel</p-button>
          <p-button type="default" simple size="sm" class="pull-right mr-2" @click.native="onReset">Reset</p-button>
          <span class="pull-right mr-4 error text-danger" v-if="error">{{error}}</span>
        </b-col>
      </b-row>
    </b-form>
    <b-loading :loading="!userAccountDetailsLoaded || processing" />
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'

export default {
  data() {
    return {
      title: "Account Details",
      subTitle: "Ensure that this information is as accurate as possible so that it properly reflected on any generated receipts.",
      processing: false,
      initial: {
      },
      form: {
        // ...this.userAccountDetails,
        error: {
          company: false,
          logo: false
        },
      },
      logoFile: null,
      logoFileContent: null,
      userAccountDetailsLoaded: false,
      // handle: 0,
    }
  },
  watch: {
    form: {
      handler() {
        this.validate()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'loading',
      'user',
      'isAuthenticated',
      'userAccountDetails'
    ]),
    // userAccountDetailsLoaded: function() {
    //   return this.isAuthenticated && !!this.userAccountDetails
    // }
  },
  methods: {
    open(initialData) {
      this.initial = initialData
      this.resetFormFields(initialData)
      this.userAccountDetailsLoaded = true
      this.$refs.accountDetailsModal.show()
    },
    close() {
      this.$refs.accountDetailsModal.hide()
    },
    validate() {
      // console.log(this.form.company)
      this.form.error.company = !this.form.company
    },
    hasError() {
      return Object.keys(this.form.error).some((key) => this.form.error[key])
    },
    onSubmit() {
      this.onSubmitForm()
    },
    onCancel() {
      this.close()
    },
    onReset() {
      this.resetFormFields()
    },
    resetFormFields() {
      this.form = {
        ...this.initial,
        error: {
          company: false,
          logo: false
        },
        // ...this.userAccountDetails
      }
      // this.form.company = this.userAccountDetails.company
      // this.form.phone = this.userAccountDetails.phone
      // this.form.logo = this.userAccountDetails.logo
      // this.form.address = {
      //   ...this.userAccountDetails.address
      // }
      this.logoFile = null
      this.logoFileContent = null
      this.processing = false
      // this.handle++
      // this.logoFileContent = null
    },
    onSubmitForm(e) {
      e && e.preventDefault()
      if (!this.hasError()) {
        this.processing = true
        const {error, ...payload} = this.form
        const logoFileUploadTask = new Promise((resolve, reject) => {
          if (this.logoFile && this.logoFileContent) {
            resolve(this.logoFileContent)
          } else {
            resolve('')
          }
        })
        logoFileUploadTask.then((newLogoUrl) => {
          if (newLogoUrl) {
            payload.logo = newLogoUrl
          }
          this.$store.dispatch('updateUser', payload)
          .then(() => {
            this.$bvToast.toast('Details have been successfully updated.', {
              title: `Account`,
              variant: 'custom',
              autoHideDelay: 2000,
              solid: true
            })
          })
          .finally(() => {
            this.processing = false
            this.close()
          })
        })
      }
    },
    companyLogoStyle() {
      const {logo, error} = this.form
      if (logo && !error.logo && !this.logoFileContent) {
        return {
          background: `url(${logo}) no-repeat center center`
        }
      }
      return {}
    },
    chooseFile(e) {
      if (this.logoFile) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {

          var image = new Image();
          
          image.onload = (imageEvent) => {

            var canvas = document.createElement('canvas'),
                max_width = 200,
                max_height = 100,
                width = image.width,
                height = image.height

            if (width > height) {
                if (width > max_width) {
                    height *= max_width / width
                    width = max_width
                }
            } else {
                if (height > max_height) {
                    width *= max_height / height
                    height = max_height
                }
            }
            canvas.width = Math.min(width, max_width)
            canvas.height = Math.min(height, max_height)
            canvas.getContext('2d').drawImage(image, 0, 0, width, height)

            this.logoFileContent = canvas.toDataURL('image/png')

          }

          image.src = reader.result

          // this.$refs['companyLogo'].src = reader.result
        }, false);
        reader.readAsDataURL(this.logoFile);
      } else {
        this.logoFileContent = null
        this.form.error.logo = false
      }
    },
    loadCompanyLogo(e) {
      if (this.$refs['companyLogo'].width > 200 || this.$refs['companyLogo'].height > 100) {
        this.form.error.logo = true
        // this.logoFile = null
      } else {
        this.form.error.logo = false
      }
    }
  },
  created() {
    // this.resetFormFields()
  },
}
</script>
<style lang="scss">
.accountDetailsModal {
  .modal-header {
    border-bottom: 0 none;
    flex-direction: column;
  }
  .form-control {
    border: solid 1px #ccc;
  }
  .form-actions {
    .btn {
      min-width: 100px;
    }
  }
  .company-logo-wrapper {
    position: relative;
    box-sizing: content-box;
    border: solid 1px #ccc;
    height: 0;
    padding-top: 50%;
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      // background: #0e0e0e;
    }
    .compnay-logo-content {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .company-logo-select {
    position: relative;
    display: inline-block;
    .file-logoFile {
      position: absolute;
      opacity: 0;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 0;
      cursor: pointer;
      text-indent: -9999px;
    }
    .btn-logoFile-select {
      min-width: 100px;
      position: relative;
      pointer-events: none;
    }
  }
}
</style>
